import { Observable, of, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { APIs } from '@app-settings/index';
import { Router, NavigationExtras } from '@angular/router';
import { HttpHeaderService } from '@app-services/http-header.service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
	private notifications_removed = new Subject<any>();
	constructor(
		private _router: Router,
		private _httpClient: HttpClient,
			private _httpHeaderService: HttpHeaderService
		) { }

	notificationsRemoved(removed_res: boolean) {
		this.notifications_removed.next({ removed: removed_res });
	}

	getUpdate(): Observable<any> {
		return this.notifications_removed.asObservable();
	}

  	getAllNotifications() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.notification}/all-notification`, { headers: headers });
	}

	getTabsNotifications() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.notification}/tab-notification`, { headers: headers });
	}

  	goToChat(notification_info){
    	if(notification_info.type == 'admin_om_chat' || notification_info.type == 'leader_conversation' || notification_info.type == 'om_seeker_conversation'){
			let navigationExtras: NavigationExtras = {
				queryParams: {
					user_uuid: notification_info.user_uuid,
					notification_uuid: notification_info.notification_uuid
				}
			};
			this._router.navigate(['/pages/admin-om-chat'], navigationExtras);
		}
  	}

	deleteNotification(notification_info) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.delete(`${APIs.notification}/delete-notification`, { params: {notification_uuid: notification_info.notification_uuid}, headers: headers });
	}

	clearNotifications() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		
		return this._httpClient.delete(`${APIs.notification}/clear-notification`, { headers: headers });
	}
}
